import * as React from "react";
const IconSave = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="m58.6 11.5-9.7-8.9-.2-.1c-.7-.5-1.5-.8-2.2-.8H11.9c-4.2 0-7.6 3.4-7.6 7.6v45.2c0 4.2 3.4 7.6 7.6 7.6h40.2c4.2 0 7.6-3.4 7.6-7.6V14.1c0-.9-.3-1.8-1.1-2.6M39.9 6.3V12H19V6.3zM21.5 57.8V39.3h21v18.4h-21zm33.7-3.2c0 1.7-1.4 3.1-3.1 3.1H47V38.4c0-1.9-1.6-3.5-3.5-3.5h-23c-1.9 0-3.5 1.6-3.5 3.5v19.4h-5.1c-1.7 0-3.1-1.4-3.1-3.1V9.4c0-1.7 1.4-3.1 3.1-3.1h2.6V13c0 1.9 1.6 3.5 3.5 3.5h22.9c1.9 0 3.5-1.6 3.5-3.5V6.3h1.8l9 8.3z" />
    <path d="M36.1 42.5h-8.2c-1.2 0-2.3 1-2.3 2.3s1 2.3 2.3 2.3h8.2c1.2 0 2.3-1 2.3-2.3s-1.1-2.3-2.3-2.3M36.1 50.1h-8.2c-1.2 0-2.3 1-2.3 2.3s1 2.3 2.3 2.3h8.2c1.2 0 2.3-1 2.3-2.3s-1.1-2.3-2.3-2.3" />
  </svg>
);
export default IconSave;
